import { sessionStorageKeys } from './sessionStorageKeys';

/**
 * Set the native platform type into session storage
 * @param nativePlatformType The native platform type to set.
 */
export function setNativePlatformType(nativePlatformType: string): void {
  sessionStorage.setItem(
    sessionStorageKeys.nativePlatformType,
    nativePlatformType
  );
}

/**
 * Get the native platform type from session storage
 */
export function getNativePlatformType(): string | null | undefined {
  return sessionStorage.getItem(sessionStorageKeys.nativePlatformType);
}
